export default "__VITE_ASSET__twyjUS7G__"